<div class="card">
    <div class="card-body">
        <h4 class="card-title">Authentification en cours...</h4>
        <on-loading></on-loading>
    </div>
</div>
